(function () {
  const sliders = document.querySelectorAll("[data-px-simple-slider]");
  if (!sliders.length) return;

  const getGap = (el) => {
    const styles = getComputedStyle(el);
    const gap = parseFloat(styles.columnGap || styles.gap || "0");
    return Number.isFinite(gap) ? gap : 0;
  };

  sliders.forEach((root) => {
    const viewport = root.querySelector("[data-px-viewport]");
    const track = root.querySelector("[data-px-track]");
    const btnPrev = root.querySelector("[data-px-prev]");
    const btnNext = root.querySelector("[data-px-next]");

    if (!viewport || !track) return;

    const getStep = () => {
      const first = track.querySelector(".px-teaser-slider__slide");
      if (!first) return 320;
      const w = first.getBoundingClientRect().width;
      return w + getGap(track);
    };

    const update = () => {
      const max = viewport.scrollWidth - viewport.clientWidth;
      const x = viewport.scrollLeft;
      const tol = 2;

      if (btnPrev) btnPrev.disabled = x <= tol;
      if (btnNext) btnNext.disabled = x >= (max - tol);
    };

    const scrollByStep = (dir) => {
      viewport.scrollBy({ left: dir * getStep(), behavior: "smooth" });
    };

    btnPrev && btnPrev.addEventListener("click", () => scrollByStep(-1));
    btnNext && btnNext.addEventListener("click", () => scrollByStep(1));

    viewport.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);

    update();
  });
})();
